export const IMAGES = {
  LOGO_NOTFOUND: '/images/notfound-logo.webp',
  LOGO_ERROR: '/images/error-logo.webp',
  PROJECT_ARCHIVED_BG: '/images/project-archived-bg.png',
  CHATBOT_PROCESSING: '/images/chatbot-processing.gif',
  CERTIFICATE_BACKGROUND: '/images/certificate-bg.webp',
  SENTIMENT_POSITIVE: '/images/positive-sentiment.png',
  SENTIMENT_NEGATIVE: '/images/negative-sentiment.png',
  SENTIMENT_NEUTRAL: '/images/neutral-sentiment.png',
};

export const RESIZE_IMAGE = 300;
